
import React from 'react';
import InternalLineItemsList from '@/components/internal/InternalLineItemsList';

const CostCenterInternalLineItemsPage = () => {
  return (
    <InternalLineItemsList />
  );
};

export default CostCenterInternalLineItemsPage;
